var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"echartstest"},[_c('div',{ref:_vm.echartRef,style:(_vm.echarStyle),attrs:{"id":_vm.echartId}})])
}
var staticRenderFns = []

export { render, staticRenderFns }